import { api } from 'data/api/api'

import { GetRefundOfferEstimateDetailsResp } from '../types/refund-offer'

export const getRefundOfferEstimateDetails = (refundOfferId: number) =>
  api.get<GetRefundOfferEstimateDetailsResp>(`/refund_offers/${refundOfferId}/refund_estimate`)
